import React, { useState, useEffect } from "react";
import "../styles/homepage.css";
import linekdin_light from "../utils/Contacts/linkedin-light.svg";
import github_light from "../utils/Contacts/github-light.svg";
import mail_light from "../utils/Contacts/mail-light.svg";
import medium_light from '../utils/Contacts/medium-light.svg'


const texts = [
  "WEB DEVELOPER",
  "Engineer",
  "CLOUD",
];

export default function HomePage({
  homeSectionRef,
  projectSectionRef,
  aboutSectionRef,
  contactSectionRef,
  publicationRef
}) {
  
  const [typedText, setTypedText] = useState("");
  const [showCursor, setShowCursor] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showOptions, setShowOptions] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setShowOptions(false);
    } else {
      setShowOptions(true);
    }
  };

  const scrollDown = (ref) => {
    window.scrollTo({
      top: ref.current.offsetTop,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    let currentText = "";
    let timer;

    const typeText = () => {
      if (currentText === texts[currentIndex]) {
        setShowCursor(true);
        timer = setTimeout(() => {
          setShowCursor(false);
          setTimeout(() => {
            currentText = "";
            setCurrentIndex((currentIndex + 1) % texts.length);
          }, 1000);
        }, 1000); 
      } else {
        currentText = texts[currentIndex].slice(0, currentText.length + 1);
        setTypedText(currentText);
      }
    };

    const intervalId = setInterval(typeText, 100); 

    return () => {
      clearInterval(intervalId);
      clearTimeout(timer);
    };
  }, [currentIndex]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
;
  return (
    <div className={`home ${showOptions ? "show-options" : ""}`}>
      <div className="home-left">
        <ul className="home-list">
          <li className="home-options" onClick={() => scrollDown(aboutSectionRef)}>About Me</li>
          <li className="home-options" onClick={() => scrollDown(projectSectionRef)}>Projects</li>
          <li className="home-options" onClick={() => scrollDown(publicationRef)}>Publications</li>
          <li className="home-options" onClick={() => scrollDown(contactSectionRef)}>Contact</li>
        </ul>
      </div>

      <div className="home-right">
        <div className="home-headline">
          <h3 className="home-typed">
            
            <span>{typedText}</span>
            {showCursor && <span className="cursor">|</span>}
          </h3>

          <p className="name">I'M <span className="homepage-name">
          Ojas Ketkar
          </span></p>
          
          <h5 className="home-tagline">
            I am a third-year undergraduate at Vishwakarma Institute of Technology pursuing B.Tech in Computer Science
          </h5>
          
          <div className="home-contact">
            <div className="home-contact">
              <a href="https://www.linkedin.com/in/ojas-ketkar" target="_blank" rel="noreferrer">
                <img src={linekdin_light} alt="linkedin" className="linkedin-home" />
              </a>
            </div>
            <div className="home-contact">
              <a href="mailto: ketkarojas@gmail.com" target="_blank" rel="noreferrer">
                <img src={mail_light} alt="" className="mail-home" />
              </a>
            </div>
            <div className="home-contact">
              <a href="https://github.com/OjasKetkar" target="_blank" rel="noreferrer">
                <img src={github_light} alt="" className="github-home" />
              </a>
            </div>
            <div className="home-contact">
              <a href="https://medium.com/@ojasketkar" target="_blank" rel="noreferrer">
                <img src={medium_light} alt="" className="medium-home" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
 
}
